export enum EstateStatus {
    OPEN = 'Open',
    CLOSED = 'Closed'
} 